(function () {
  'use strict';

  var FALLBACK_MATERIAL_LABELS = {
    silver: 'Sterling Silver',
    plated: 'Gold Plated',
    solid: 'Solid 14K Gold'
  };

  var FALLBACK_STONE_LABELS = {
    sapphire: 'Lab-Grown Sapphire',
    pink: 'Lab-Grown Pink Diamond',
    white: 'Lab-Grown White Diamond'
  };

  function money(value) {
    var amount = Number(value) || 0;
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: Math.round(amount * 100) % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function stoneToken(value) {
    var text = String(value || '').toLowerCase();
    if (text.indexOf('pink') !== -1) return 'pink';
    if (text.indexOf('white') !== -1) return 'white';
    return 'sapphire';
  }

  function selectedVariant(form) {
    var input = form && form.querySelector('[name="id"]');
    var product = form && window._themeProducts && window._themeProducts[form.dataset.productId];
    var id = Number(input && input.value);
    if (!product || !Array.isArray(product.variants)) return { id: id || null, title: '' };
    return product.variants.find(function (variant) { return Number(variant.id) === id; }) || { id: id || null, title: '' };
  }

  function catalog() {
    return window.DV_NATIVE_CATALOG || {};
  }

  function curatedSetPrice(root) {
    var prices = {
      'daisy-day-necklace-set': 328,
      'paw-promise-bracelet-set': 364,
      'endless-necklace-set': 478,
      'flutter-necklace-set': 478
    };
    return prices[root.dataset.productHandle] || null;
  }

  function selectedSetPrice(root, form, product, stone, chain) {
    var originalPrice = curatedSetPrice(root) || variantPriceDollars(form);
    if (!chain || chain.id === root.dataset.setChain) return originalPrice;
    var charm = product.silver[stone] || product.silver.sapphire;
    return charm[0] + Number(chain.price);
  }

  function productFor(family) {
    var products = catalog().products;
    if (!Array.isArray(products)) return null;
    var product = products.find(function (item) { return item && item.id === family; });
    if (!product) return null;
    var spec = catalog().goldSpecs && catalog().goldSpecs[family];
    return Object.assign({}, product, {
      weight: spec && spec.weight,
      drop: spec && spec.drop,
      goldStone: spec && spec.stones
    });
  }

  function accessoryFor(handle) {
    return catalog().accessories && catalog().accessories[handle] || null;
  }

  function platedAccessoryFor(accessory) {
    var options = catalog().platedChainOptions;
    return Array.isArray(options) ? options.find(function (item) {
      return item && accessory && item.id === accessory.id;
    }) : null;
  }

  function platedAccessoryPrice(accessory) {
    var option = platedAccessoryFor(accessory);
    var explicit = Number(option && option.standalonePrice);
    if (Number.isFinite(explicit)) return explicit;
    return accessory && String(accessory.id).indexOf('bracelet') !== -1 ? 99 : 149;
  }

  function chainFor(id) {
    var options = catalog().chainOptions;
    return Array.isArray(options) ? options.find(function (item) { return item.id === id; }) : null;
  }

  function platedChainAvailability(id) {
    if (!id || id === 'none') return 'available';
    var settings = window.DV_CHAIN_AVAILABILITY || {};
    var value = settings[id];
    return value === 'available' || value === 'hidden' || value === 'waitlist' ? value : 'waitlist';
  }

  function platedChainFor(id) {
    var options = catalog().platedChainOptions;
    if (platedChainAvailability(id) === 'hidden') return null;
    return Array.isArray(options) ? options.find(function (item) { return item.id === id; }) : null;
  }

  function chainSelectionExists(id) {
    return Boolean(chainFor(id) || platedChainFor(id));
  }

  function standaloneChainPrice(chain, reference) {
    var explicit = Number(chain && chain.standalonePrice);
    if (Number.isFinite(explicit)) return explicit;
    var accessoryPrice = Number(reference && reference.price);
    return Number.isFinite(accessoryPrice) ? accessoryPrice : null;
  }

  function bundleSaving(chain, reference) {
    var standalone = standaloneChainPrice(chain, reference);
    var bundle = Number(chain && chain.price);
    return Number.isFinite(standalone) && Number.isFinite(bundle) && standalone > bundle ? standalone - bundle : 0;
  }

  function compatibleSetChain(id, defaultId) {
    var candidate = chainFor(id);
    if (!candidate || candidate.id === 'none') return null;
    return (candidate.id.indexOf('bracelet') !== -1) === (String(defaultId).indexOf('bracelet') !== -1) ? candidate : null;
  }

  function variantPriceDollars(form) {
    var variant = selectedVariant(form);
    var value = Number(variant && variant.price);
    return Number.isFinite(value) ? value / 100 : null;
  }

  function quantityFor(form) {
    var input = form && form.querySelector('[name="quantity"]');
    var quantity = Math.trunc(Number(input && input.value) || 1);
    return Math.min(99, Math.max(1, quantity));
  }

  function accessoryForChain(id) {
    var accessories = catalog().accessories || {};
    return Object.keys(accessories).map(function (handle) { return accessories[handle]; }).find(function (item) {
      return item && item.id === id;
    }) || null;
  }

  function materialLabels() {
    return Object.assign({}, FALLBACK_MATERIAL_LABELS, catalog().materialLabels || {});
  }

  function materialName(material) {
    return material === 'silver' ? 'Rhodium-Plated .925 Sterling Silver' : materialLabels()[material];
  }

  function accessoryMaterialName(material) {
    return material === 'plated' ? '18K Gold-Plated .925 Sterling Silver' : materialName('silver');
  }

  function stoneLabels() {
    return Object.assign({}, FALLBACK_STONE_LABELS, catalog().stoneLabels || {});
  }

  function goldStoneLabel(family) {
    return family === 'blossom' ? 'Lab-Grown White Diamond + Lab-Grown Emerald' : 'Lab-Grown White Diamond';
  }

  function goldAboutHTML(product, material, family, selectedChain) {
    var details = {
      daisy: { gemstones: 'One round 3 mm lab-grown white diamond', weight: '0.10 carats' },
      bound: { gemstones: 'One round 3 mm lab-grown white diamond', weight: '0.10 carats' },
      paw: { gemstones: 'Four round 1.7 mm lab-grown white diamonds', weight: '0.072 carats combined' },
      flutter: { gemstones: 'One marquise-cut 6 × 3 mm lab-grown white diamond', weight: '0.25 carats' },
      blossom: {
        gemstones: 'Ten round 2 mm lab-grown white diamonds in the flowers and two marquise-cut 4 × 2 mm lab-grown emerald leaves',
        weight: '0.30 carats of lab-grown white diamonds + 0.20 carats of lab-grown emeralds (0.50 carats combined)'
      },
      endless: {
        gemstones: 'One round 5 mm lab-grown white center diamond, surrounded by twenty round 1.2 mm lab-grown white diamonds',
        weight: '0.50 carats in the center diamond + 0.18 carats in the surrounding diamonds (0.68 carats combined)'
      }
    }[family];
    var metal = material === 'plated'
      ? '.925 sterling silver with 2.5-micron gold plating'
      : 'Solid 14K yellow gold';
    var explanation = material === 'plated'
      ? 'A sterling-silver core finished with a 2.5-micron layer of gold for a warm yellow-gold appearance. The charm and its openable lock share this gold-plated finish.'
      : 'The charm is solid 14K yellow gold. An openable DIVETIA lock is included.';
    var included = selectedChain
      ? 'Charm, openable DIVETIA lock and ' + selectedChain.name + ' included. Charm shown; selected chain not pictured.'
      : 'Wear it on one of our sterling silver chains or your own.';
    return '<ul>' +
      '<li><strong>Gemstones:</strong> ' + details.gemstones + '</li>' +
      '<li><strong>Signature gemstone:</strong> One DIVETIA Blue lab-grown diamond set in the openable lock</li>' +
      '<li><strong>Approx. main-stone weight:</strong> ' + details.weight + '<span class="dv-pdp-proof__explain">Main-stone weight excludes the separate DIVETIA Blue lock diamond.</span></li>' +
      '<li><strong>Metal:</strong> ' + metal + '<span class="dv-pdp-proof__explain">' + explanation + '</span></li>' +

      '<li><strong>Included:</strong> ' + included + '</li>' +
      '</ul><p class="dv-pdp-proof__note">Stone weights' + ' are' + ' approximate; individual pieces may vary slightly.</p>';
  }

  function platedAccessoryAboutHTML(product) {
    var details = String(product.detail || '').split('. ').slice(1).join('. ').replace(/\s*Chain only; charms sold separately\.?$/i, '');
    return '<ul>' +
      '<li><strong>Metal:</strong> .925 sterling silver with 18K gold plating—not solid gold.</li>' +
      (details ? '<li><strong>Details:</strong> ' + details + '</li>' : '') +
      '<li><strong>Included:</strong> Chain only; charms sold separately.</li>' +
      '</ul>';
  }

  function writeState(state, push) {
    if (state.goldPage) return; // A gold product URL is already canonical.
    try {
      var url = new URL(window.location.href);
      if (window.DV_COMMERCE_EFFECTIVE_MODE === 'live') {
        url.searchParams.delete('preview_theme_id');
        url.searchParams.delete('dv_commerce');
      } else {
        url.searchParams.set('preview_theme_id', catalog().previewTheme);
        if (window.DV_COMMERCE_EFFECTIVE_MODE === 'test') url.searchParams.set('dv_commerce', 'test');
      }
      var nativeStone = state.kind === 'charm' && state.product.native && state.product.native[state.stone];
      if (nativeStone && nativeStone[2]) url.pathname = '/products/' + nativeStone[2];
      // A variant ID belongs to one Shopify product handle. Stone changes use
      // canonical handles, so carrying the old ID would select a foreign variant
      // after a reload (and can override the new handle again).
      if (state.kind === 'charm') url.searchParams.delete('variant');
      if (state.material === 'silver') url.searchParams.delete('dv_material');
      else url.searchParams.set('dv_material', state.material);
      if (state.material !== 'silver' || !state.chain || state.chain === 'none') url.searchParams.delete('dv_chain');
      else url.searchParams.set('dv_chain', state.chain);
      window.history[push ? 'pushState' : 'replaceState']({}, '', url.toString());
    } catch (_error) {}
  }

  function setButtonText(button, label) {
    if (!button) return;
    var text = button.querySelector('.atc-text');
    if (text) text.textContent = label;
    else button.textContent = label;
    button.setAttribute('aria-label', label);
    // The theme's async product-form init and variant updates rewrite .atc-text from data-atc-text
    // (falling back to "Add to bag"); keep it in step so a late theme pass can't revert our label.
    button.setAttribute('data-atc-text', label);
  }

  function syncSilverOptionLabels(section, product, selectedStone) {
    var picker = section.querySelector('.main-product__block-variant_picker');
    if (!picker) return;
    picker.querySelectorAll('.product-option-item[data-value]').forEach(function (option) {
      if (!option.dataset.dvRawLabel) {
        option.dataset.dvRawLabel = String(option.dataset.value || option.value || option.textContent.trim())
          .replace(/\s*[—–-]\s*\$[\d,.]+(?:\s*USD)?\s*$/i, '')
          .trim();
      }
      var token = stoneToken(option.dataset.dvRawLabel);
      var pair = product.silver[token];
      if (!pair) return;
      if (option.tagName === 'OPTION' && !option.hasAttribute('value')) option.setAttribute('value', option.dataset.dvRawLabel);
      var desired = option.dataset.dvRawLabel + ' — ' + money(pair[0]);
      if (option.textContent !== desired) option.textContent = desired;
    });
    picker.querySelectorAll('[data-option-label]').forEach(function (label) {
      var desired = stoneLabels()[selectedStone] + ' — ' + money((product.silver[selectedStone] || product.silver.sapphire)[0]);
      if (label.textContent !== desired) label.textContent = desired;
    });
  }

  function stoneFromPath(product) {
    var handle = window.location.pathname.split('/').filter(Boolean).pop();
    var native = product && product.native || {};
    return Object.keys(native).find(function (stone) {
      return native[stone] && native[stone][2] === handle;
    }) || null;
  }

  function explicitVariantStone(form, product, params) {
    var requestedId = params.get('variant');
    var nativeProduct = form && window._themeProducts && window._themeProducts[form.dataset.productId];
    if (!requestedId || !nativeProduct || !Array.isArray(nativeProduct.variants)) return null;
    var variant = nativeProduct.variants.find(function (item) {
      return String(item.id) === requestedId;
    });
    if (!variant) return null; // Foreign/unknown IDs must not override this product.
    var title = String(variant.title || '').toLowerCase();
    var stone = title.indexOf('pink') !== -1 ? 'pink' : title.indexOf('white') !== -1 ? 'white' : title.indexOf('sapphire') !== -1 ? 'sapphire' : null;
    return stone && product.silver[stone] ? stone : null;
  }

  function selectedStoneFromPicker(section) {
    var selected = section.querySelector('.main-product__block-variant_picker option.product-option-item:checked, .main-product__block-variant_picker .product-option-item[aria-checked="true"], .main-product__block-variant_picker .product-option-item[aria-pressed="true"]');
    return selected ? stoneToken(selected.dataset.value || selected.dataset.dvRawLabel || selected.textContent) : null;
  }

  function restoreNativeStoneSelection(section, product, stone) {
    var picker = section.querySelector('.main-product__block-variant_picker');
    if (!picker || !product.silver[stone]) return;
    syncSilverOptionLabels(section, product, stone);
    var option = Array.prototype.slice.call(picker.querySelectorAll('.product-option-item[data-value]')).find(function (item) {
      return stoneToken(item.dataset.value || item.dataset.dvRawLabel) === stone;
    });
    if (!option) return;
    if (option.tagName === 'OPTION') {
      var select = option.closest('select');
      if (!select || option.selected) return;
      option.selected = true;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (option.getAttribute('aria-checked') !== 'true' && option.getAttribute('aria-pressed') !== 'true') option.click();
  }

  function primarySilverImage(section) {
    var familyGallery = catalog().gallery && catalog().gallery[section.querySelector('[data-dv-native-pdp]').dataset.family];
    var currentStone = stoneToken(selectedVariant(section.querySelector('form[data-product-id]')).title);
    if (familyGallery && familyGallery[currentStone] && familyGallery[currentStone][0]) return familyGallery[currentStone][0];
    var image = section.querySelector('.sf-prod-media__wrapper img');
    return image ? (image.currentSrc || image.src || '') : '';
  }

  // Solid 14K gold media is rendered inside the theme's own product gallery: the same
  // .sf-prod-media-item markup, the same desktop two-column list, the same mobile Swiper
  // (pagination, swipe, autoHeight) and the same GLightbox zoom as silver. Gold items are
  // added once, shown only while Solid 14K Gold is selected, and silver items are never
  // modified, so switching back to Silver restores the original gallery exactly.
  var GOLD_NOTE = '';
  var GOLD_WIDTHS = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944];

  function goldSized(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function goldSrcset(src) {
    return GOLD_WIDTHS.map(function (width) {
      return goldSized(src, width) + ' ' + width + 'w';
    }).join(', ') + ', ' + src + ' 2000w';
  }

  function goldProductHelper(section) {
    var form = section.querySelector('form[data-product-id]');
    if (!form || typeof window._getProductInstances !== 'function') return null;
    // The theme looks instances up by numeric product ID (a string argument means handle).
    var instances = window._getProductInstances(Number(form.dataset.productId)) || [];
    var instance = instances.find(function (item) { return item && item.productForm === form; }) || instances[0];
    return instance && instance.productHelper || null;
  }

  function createGoldGallery(section, root, product) {
    var wrapper = section.querySelector('.sf-prod-media__wrapper');
    var desktopList = section.querySelector('.sf-product-media__desktop .flex-grow');
    var mobileSlider = section.querySelector('.sf-product-media__mobile .swiper-container');
    var mobileList = mobileSlider && mobileSlider.querySelector('.swiper-wrapper');
    var family = root.dataset.family;
    var entries = (catalog().goldGallery && catalog().goldGallery[family]) || [];
    var videoEntry = catalog().goldVideos && catalog().goldVideos[family];
    entries = entries.filter(function (entry) {
      return entry.video ? Boolean(videoEntry && videoEntry.src) : Boolean(entry.src);
    });
    if (!wrapper || !desktopList || !mobileList || !entries.length) return null;

    var built = false;
    var solidActive = false;
    var goldItems = [];
    var videos = [];
    var note = null;

    function zoomTemplate(list) {
      var zoom = list.querySelector('.sf-prod-media-item:not(.dv-native-gold-item) .zoom-in');
      return zoom ? zoom.cloneNode(true) : null;
    }

    function buildItem(entry, index, layout, zoom) {
      var isVideo = Boolean(entry.video);
      var item = document.createElement('div');
      var media = document.createElement('div');
      item.className = (layout === 'mobile' ? 'swiper-slide ' : '') + 'sf-prod-media-item media-type-' + (isVideo ? 'video' : 'image') +
        (layout === 'desktop' ? ' overflow-hidden relative group' : '') + ' dv-native-gold-item';
      item.setAttribute('data-index', 'dv-gold-' + index);
      item.setAttribute('data-dv-gold-index', String(index));
      if (layout === 'mobile') item.setAttribute('data-media-type', isVideo ? 'video' : 'image');
      if (isVideo) {
        var video = document.createElement('video');
        // No media-video/local-video: the theme wraps those in Plyr, which collapses this
        // absolutely positioned video to 0px and leaves only the gray tile background.
        media.className = 'sf-prod-media dv-native-gold-video';
        if (entry.background) media.style.background = entry.background;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'none';
        // Keep a real still visible even before lazy media attaches or autoplay starts.
        if (videoEntry.poster) video.poster = videoEntry.poster;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('aria-label', product.name + ' in solid 14K gold, motion view');
        media.appendChild(video);
        videos.push(createGoldMotion(item, video, videoEntry));
      } else {
        var frame = document.createElement('div');
        var image = document.createElement('img');
        media.className = 'sf-prod-media media-image';
        media.style.setProperty('--aspect-ratio', '1.0');
        frame.className = 'sf-image';
        frame.setAttribute('data-image-wrapper', '');
        frame.style.setProperty('--aspect-ratio', '1.0');
        image.src = goldSized(entry.src, 720);
        image.srcset = goldSrcset(entry.src);
        image.sizes = layout === 'mobile' ? '(max-width: 767px) calc(100vw - 28px), 1px' : '(min-width: 768px) 50vw, 1px';
        image.width = 2000;
        image.height = 2000;
        image.alt = entry.alt || product.name + ' in solid 14K gold';
        image.decoding = 'async';
        if (index > 1) image.loading = 'lazy';
        image.addEventListener('load', updateSlider);
        frame.appendChild(image);
        media.appendChild(frame);
      }
      if (layout === 'mobile' && zoom) item.appendChild(zoom.cloneNode(true));
      item.appendChild(media);
      if (layout === 'desktop' && zoom) item.appendChild(zoom.cloneNode(true));
      return item;
    }

    function build() {
      if (built) return;
      built = true;
      var desktopZoom = zoomTemplate(desktopList);
      var mobileZoom = zoomTemplate(mobileList);
      entries.forEach(function (entry, index) {
        var desktopItem = buildItem(entry, index, 'desktop', desktopZoom);
        var mobileItem = buildItem(entry, index, 'mobile', mobileZoom);
        goldItems.push({ desktop: desktopItem, mobile: mobileItem });
      });
      note = document.createElement('p');
      note.className = 'dv-native-gold-media__note';
      note.setAttribute('data-dv-gold-note', '');
      note.textContent = GOLD_NOTE;
      note.hidden = true;
      wrapper.appendChild(note);
      placeItems();
      new MutationObserver(function () {
        if (solidActive && firstSlide(mobileList) !== goldItems[0].mobile) {
          placeItems();
          updateSlider(true);
        }
      }).observe(mobileList, { childList: true });
      window.addEventListener('click', openLightbox, true);
    }

    // Swiper loop clones (desktop widths only, inside the hidden mobile list) are not slides.
    function firstSlide(list) {
      var child = list.firstElementChild;
      while (child && child.classList.contains('swiper-slide-duplicate')) child = child.nextElementSibling;
      return child;
    }

    // Visible slides must lead the Swiper wrapper; hidden ones trail it (as the theme's
    // variant-media switch does for silver), so activeIndex/autoHeight track real slides.
    function placeItems() {
      var desktopAnchor = solidActive ? desktopList.firstElementChild : null;
      var mobileAnchor = solidActive ? firstSlide(mobileList) : null;
      goldItems.forEach(function (pair) {
        if (desktopAnchor === pair.desktop) desktopAnchor = pair.desktop.nextElementSibling;
        else desktopList.insertBefore(pair.desktop, desktopAnchor);
        if (mobileAnchor === pair.mobile) mobileAnchor = pair.mobile.nextElementSibling;
        else mobileList.insertBefore(pair.mobile, mobileAnchor);
      });
    }

    var sliderPending = false;
    function updateSlider(reset) {
      var swiper = mobileSlider.swiper;
      if (!swiper || typeof swiper.update !== 'function') return;
      if (reset === true) {
        swiper.update();
        swiper.slideTo(0, 0);
        return;
      }
      if (sliderPending) return;
      sliderPending = true;
      window.requestAnimationFrame(function () {
        sliderPending = false;
        if (typeof swiper.updateAutoHeight === 'function') swiper.updateAutoHeight(0);
      });
    }

    function lightboxElements() {
      return entries.map(function (entry) {
        return entry.video ? { href: videoEntry.src, type: 'video' } : { href: entry.src, type: 'image' };
      });
    }

    var silverLightbox = null;
    var lightboxOwner = null;

    // The theme's GLightbox instance holds the silver media list; gold borrows it while
    // open and the silver list is put back before any silver zoom.
    function restoreSilverLightbox() {
      if (!lightboxOwner || !silverLightbox || lightboxOwner.lightboxOpen) return;
      lightboxOwner.elements = silverLightbox;
      lightboxOwner = null;
    }

    function openLightbox(event) {
      if (!solidActive) {
        if (lightboxOwner && event.target && event.target.closest && section.contains(event.target)) restoreSilverLightbox();
        return;
      }
      var item = event.target && event.target.closest && event.target.closest('.dv-native-gold-item');
      if (!item || !section.contains(item)) return;
      var swiper = mobileSlider.swiper;
      if (item.parentElement === mobileList && swiper && swiper.allowClick === false) return;
      var isZoom = event.target.closest('.sf-prod-media__zoom-in');
      if (!isZoom && !item.classList.contains('media-type-image')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var helper = goldProductHelper(section);
      if (!helper || !helper.lightbox || typeof helper.lightbox.setElements !== 'function') return;
      if (helper.currPlayer && typeof helper.currPlayer.pause === 'function') helper.currPlayer.pause();
      if (!lightboxOwner) silverLightbox = helper.lightbox.elements;
      lightboxOwner = helper.lightbox;
      helper.lightbox.setElements(lightboxElements());
      helper.lightbox.openAt(Number(item.dataset.dvGoldIndex) || 0);
    }

    return {
      sync: function (isSolid) {
        var changed = isSolid !== solidActive;
        if (isSolid) build();
        if (!built) return;
        solidActive = isSolid;
        note.hidden = true;
        if (changed) {
          if (!isSolid) restoreSilverLightbox();
          placeItems();
          updateSlider(true);
          // Restore the silver ordering, active set and silver lightbox elements.
          if (!isSolid && window.DivetiaVariantMediaSwitch && typeof window.DivetiaVariantMediaSwitch.sync === 'function') {
            window.DivetiaVariantMediaSwitch.sync();
          }
        }
        videos.forEach(function (motion) { motion.sync(isSolid); });
      }
    };
  }

  function createGoldMotion(tile, video, entry) {
    var solidActive = false;
    var inView = false;
    var sourceAttached = false;
    var userPaused = false;
    var lastIntent = 0;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function canShowVideo() {
      return solidActive && inView && !document.hidden;
    }

    function pauseAndUnload() {
      if (!video.paused) video.pause();
      if (sourceAttached) {
        video.removeAttribute('src');
        video.load();
        sourceAttached = false;
      }
    }

    function play() {
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    }

    function sync() {
      if (!canShowVideo()) {
        pauseAndUnload();
        return;
      }
      if (!sourceAttached) {
        if (entry.poster) video.poster = entry.poster;
        video.src = entry.src;
        sourceAttached = true;
        video.load();
      }
      if ((reducedMotion && reducedMotion.matches) || userPaused || !video.paused) return;
      play();
    }

    // Like the silver motion slide (autoplaying, controls hidden), a tap toggles playback.
    tile.addEventListener('click', function (event) {
      if (event.target.closest('.sf-prod-media__zoom-in')) return;
      lastIntent = Date.now();
      if (video.paused) {
        userPaused = false;
        sync();
        if (sourceAttached) play();
      } else {
        userPaused = true;
        video.pause();
      }
    });
    // Other gallery scripts pause videos in inactive silver items; only a viewer's tap
    // may keep the gold motion paused.
    video.addEventListener('pause', function () {
      if (Date.now() - lastIntent < 800) return;
      if (canShowVideo() && sourceAttached && !userPaused) window.setTimeout(sync, 0);
    });
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('pagehide', pauseAndUnload);
    if (reducedMotion) {
      var onMotionPreference = function () {
        if (reducedMotion.matches && !video.paused) video.pause();
        else sync();
      };
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onMotionPreference);
      else if (reducedMotion.addListener) reducedMotion.addListener(onMotionPreference);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (observed) {
        inView = observed[0].isIntersecting && observed[0].intersectionRatio >= 0.5;
        sync();
      }, { threshold: [0, 0.5] }).observe(tile);
    } else {
      inView = true;
    }
    return {
      sync: function (isSolid) {
        solidActive = isSolid;
        if (!isSolid) userPaused = false;
        sync();
      }
    };
  }

  function dispatchReview(root, state) {
    var variant = selectedVariant(state.form);
    var quantity = quantityFor(state.form);
    if (state.kind === 'accessory') {
      var accessoryIsPlated = state.material === 'plated';
      var accessoryAvailability = accessoryIsPlated ? platedChainAvailability(state.product.id) : 'available';
      var accessoryPrice = accessoryIsPlated ? platedAccessoryPrice(state.product) : state.product.price;
      window.dispatchEvent(new CustomEvent('dv:native:add', { detail: { items: [{
        materialKey: state.material,
        chainId: state.product.id,
        id: accessoryIsPlated ? state.product.id + ':plated' : (variant.id || root.dataset.productId),
        title: state.product.name,
        variant: accessoryIsPlated ? '18K Gold Plated' : (variant.title || 'Default Title'),
        material: accessoryMaterialName(state.material),
        stone: null,
        chain: state.product.name,
        price: accessoryPrice,
        compareAt: null, // Silver chains have no live compare-at price.
        quantity: quantity,
        image: state.product.image || primarySilverImage(state.section),
        url: window.location.pathname + window.location.search,
        mode: accessoryIsPlated && accessoryAvailability !== 'available' ? 'waitlist' : 'cart',
        components: [{
          role: 'chain',
          id: accessoryIsPlated ? state.product.id + ':plated' : (variant.id || root.dataset.productId),
          title: state.product.name,
          material: accessoryIsPlated ? 'plated' : 'silver',
          price: accessoryPrice
        }]
      }] } }));
      return;
    }

    if (state.kind === 'set') {
      var setPair = state.product.silver[state.stone] || state.product.silver.sapphire;
      var setChain = chainFor(state.chain);
      var setChainReference = setChain && accessoryForChain(setChain.id);
      var customPair = Boolean(setChain && setChain.id !== root.dataset.setChain);
      var selectedPrice = selectedSetPrice(root, state.form, state.product, state.stone, setChain);
      window.dispatchEvent(new CustomEvent('dv:native:add', { detail: { items: [{
        source: 'curated-set',
        design: state.family,
        stoneKey: state.stone,
        chainId: setChain && setChain.id,
        defaultChainId: root.dataset.setChain,
        setVariantId: Number(variant.id) || null,
        id: variant.id || root.dataset.productId,
        title: root.dataset.productTitle,
        variant: variant.title || 'Curated set',
        material: 'Rhodium-Plated .925 Sterling Silver',
        stone: stoneLabels()[state.stone],
        chain: setChain && setChain.name,
        price: selectedPrice,
        compareAt: customPair ? null : setPair[1] + (setChainReference && setChainReference.native ? setChainReference.native[3] : 0),
        quantity: quantity,
        image: primarySilverImage(state.section),
        url: window.location.pathname + window.location.search,
        mode: 'cart',
        components: [
          { role: 'charm', id: state.product.native[state.stone][0], title: state.product.name + ' Charm', price: setPair[0] },
          { role: 'chain', id: setChainReference && setChainReference.native ? setChainReference.native[0] : setChain && setChain.id, title: setChain && setChain.name, material: setChain && setChain.material || 'silver', price: selectedPrice - setPair[0] }
        ]
      }] } }));
      return;
    }

    var isSilver = state.material === 'silver';
    var pricePair = state.product.silver[state.stone] || state.product.silver.sapphire;
    var selectedChain = isSilver ? chainFor(state.chain) : null;
    if (selectedChain && selectedChain.id === 'none') selectedChain = null;
    var chainReference = isSilver && selectedChain && accessoryForChain(selectedChain.id);
    var itemPrice = (isSilver ? pricePair[0] : state.product[state.material]) + (selectedChain ? selectedChain.price : 0);
    var compareAt = isSilver ? pricePair[1] + (selectedChain ? standaloneChainPrice(selectedChain, chainReference) : 0) : null;
    var item = {
      design: state.family,
      materialKey: state.material,
      stoneKey: state.stone,
      chainId: selectedChain && selectedChain.id || 'none',
      id: isSilver ? (variant.id || root.dataset.productId) : state.family + ':' + state.material,
      title: state.product.name + ' Charm',
      variant: isSilver ? (variant.title || stoneLabels()[state.stone]) : goldStoneLabel(state.family),
      material: materialName(state.material),
      stone: isSilver ? stoneLabels()[state.stone] : state.product.goldStone,
      chain: selectedChain && selectedChain.name || null,
      price: itemPrice,
      compareAt: compareAt,
      quantity: quantity,
      image: isSilver ? primarySilverImage(state.section) : (catalog().goldAssets && catalog().goldAssets[state.family] || ''),
      url: window.location.pathname + window.location.search,
      mode: state.material === 'plated' ? 'waitlist' : 'cart',
      fulfillment: state.material === 'solid' ? 'Made for you · Ships within 2–3 weeks' : null
    };
    item.components = [{ role: 'charm', id: isSilver ? variant.id : state.family + ':' + state.material, title: state.product.name + ' Charm', price: isSilver ? pricePair[0] : state.product[state.material] }];
    if (selectedChain) item.components.push({ role: 'chain', id: chainReference && chainReference.native ? chainReference.native[0] : selectedChain.id, title: selectedChain.name, material: selectedChain.material || (isSilver ? 'silver' : 'plated'), price: selectedChain.price });
    window.dispatchEvent(new CustomEvent('dv:native:add', { detail: { items: [item] } }));
  }

  function init(root) {
    if (root.dataset.dvReady === 'true') return;
    root.dataset.dvReady = 'true';

    var section = root.closest('[data-section-type="product-page"]');
    var form = root.closest('form[data-product-id]');
    if (!section || !form) return;

    var family = root.dataset.family;
    var kind = root.dataset.kind || 'charm';
    var product = kind === 'accessory' ? accessoryFor(root.dataset.productHandle) : productFor(family);
    if (!product) return;

    var params = new URLSearchParams(window.location.search);
    var query = params.get('dv_material');
    var queryChain = params.get('dv_chain');
    var pathStone = kind === 'charm' ? stoneFromPath(product) : null;
    var queryStone = kind === 'charm' ? explicitVariantStone(form, product, params) : null;
    var state = {
      family: family,
      kind: kind,
      product: product,
      section: section,
      form: form,
      material: kind === 'charm' && query === 'solid' ? 'solid' : 'silver', // Plated links resolve to silver.
      stone: kind === 'set' ? root.dataset.setStone : queryStone || pathStone || stoneToken(selectedVariant(form).title || root.dataset.productTitle),
      chain: kind === 'set' ? (compatibleSetChain(queryChain, root.dataset.setChain) ? queryChain : root.dataset.setChain) : kind === 'charm' ? (chainSelectionExists(queryChain) ? queryChain : 'none') : null
    };

    // Served at its own /products/*-solid-14k-gold URL, a gold product page always opens in gold.
    if (kind === 'charm' && /-solid-14k-gold$/.test(root.dataset.productHandle || '')) {
      state.goldPage = true;
      state.material = 'solid';
      state.chain = 'none';
    }
    if (query === 'plated' || (kind !== 'charm' && query === 'solid')) writeState(state, false);
    var goldGallery = kind === 'charm' ? createGoldGallery(section, root, product) : null;
    // A gold product with a single image renders no swiper; keep its own media instead of an empty gallery.
    if (state.goldPage && !goldGallery) section.classList.add('dv-gold-native-media');
    section.classList.add('dv-native-pdp-active');
    section.classList.add('dv-native-pdp-kind-' + kind);
    document.documentElement.classList.add('dv-native-pdp-page');

    var priceNode = root.querySelector('[data-dv-price]');
    var chainFieldset = root.querySelector('[data-dv-chain-fieldset]');
    var chainDisclosure = root.querySelector('[data-dv-chain-disclosure]');
    var chainSummary = root.querySelector('[data-dv-chain-summary]');
    var stoneFieldset = root.querySelector('[data-dv-stone-fieldset]');
    var stoneOptionsNode = root.querySelector('[data-dv-stone-options]');
    var stoneCombination = root.querySelector('[data-dv-stone-combination]');
    var materialNote = root.querySelector('[data-dv-material-note]');
    var materialFieldset = root.querySelector('[data-dv-material-fieldset]');
    var availabilityNode = root.querySelector('[data-dv-availability]');
    var titleContainer = section.querySelector('.prod__title') || section;
    var nativeTitleRows = Array.prototype.slice.call(section.querySelectorAll('[data-divetia-variant-title], .prod__title h1')).map(function (node) {
      return { node: node, text: node.textContent };
    });
    var detailsProof = section.querySelector('.dv-pdp-proof--details');
    var endlessDescription = family === 'endless' ? section.querySelector('.product__description') : null;
    var goldProof = null;
    if (detailsProof) {
      goldProof = document.createElement('div');
      goldProof.className = 'dv-pdp-proof dv-pdp-proof--details dv-native-gold-proof';
      goldProof.hidden = true;
      detailsProof.insertAdjacentElement('afterend', goldProof);
    }
    var deliveryButton = Array.prototype.slice.call(section.querySelectorAll('.sf__accordion-button')).find(function (button) {
      return button.textContent.trim().toLowerCase() === 'delivery & returns';
    });
    var deliveryContent = deliveryButton && deliveryButton.parentElement.querySelector('.sf__accordion-content .prose');
    var deliveryHTML = deliveryContent ? deliveryContent.innerHTML : '';
    var sharedReturnsSource = document.querySelector('template[data-divetia-returns-copy]');
    if (deliveryContent && sharedReturnsSource) {
      var silverDeliverySnapshot = document.createElement('div');
      silverDeliverySnapshot.innerHTML = deliveryHTML;
      if (!silverDeliverySnapshot.querySelector('[data-divetia-shared-returns]')) {
        var silverReturnParagraphs = silverDeliverySnapshot.querySelectorAll('p');
        for (var silverReturnIndex = 0; silverReturnIndex < silverReturnParagraphs.length; silverReturnIndex++) {
          if (!/^Returns:\s*/.test(silverReturnParagraphs[silverReturnIndex].textContent.trim())) continue;
          var silverReturnBlock = document.createElement('div');
          silverReturnBlock.className = 'divetia-returns-copy';
          silverReturnBlock.setAttribute('data-divetia-shared-returns', '');
          silverReturnBlock.innerHTML = '<p><strong>Returns:</strong></p>' + sharedReturnsSource.innerHTML;
          silverReturnParagraphs[silverReturnIndex].replaceWith(silverReturnBlock);
          break;
        }
      }
      deliveryHTML = silverDeliverySnapshot.innerHTML;
    }
    var setIntro = section.querySelector('.dv-set-intro__contents');
    var setFoundation = Array.prototype.slice.call(section.querySelectorAll('.dv-set-details li')).find(function (item) {
      return item.textContent.trim().indexOf('Necklace or bracelet:') === 0;
    });
    var pairingButton = Array.prototype.slice.call(section.querySelectorAll('.sf__accordion-button')).find(function (button) {
      return button.textContent.trim().toLowerCase() === 'why this pairing works';
    });
    var pairingParagraph = pairingButton && pairingButton.parentElement.querySelector('.sf__accordion-content .prose p, .sf__accordion-content p');
    var pairingHTML = pairingParagraph ? pairingParagraph.innerHTML : '';
    var setPhotoContext = null;
    if (kind === 'set' && chainFieldset) {
      setPhotoContext = document.createElement('p');
      setPhotoContext.className = 'dv-native-pdp__photo-context';
      setPhotoContext.hidden = true;
      chainFieldset.appendChild(setPhotoContext);
    }
    var nativeButton = form.querySelector('.add-to-cart[type="submit"], button[name="add"][type="submit"]');
    var stickyButton = document.querySelector('.prod__sticky-atc .add-to-cart, .prod__sticky-atc button[name="add"]');
    var mobileAtc = root.querySelector('[data-dv-mobile-atc]') || document.querySelector('body > [data-dv-mobile-atc]');
    var mobileButton = mobileAtc && mobileAtc.querySelector('[data-dv-mobile-add]');
    var mobilePrice = mobileAtc && mobileAtc.querySelector('[data-dv-mobile-price]');
    // Portal the mobile bar to <body> so no section stacking context (e.g. later image sections)
    // can paint over it or intercept taps; element references and listeners are preserved.
    if (mobileAtc && mobileAtc.parentNode !== document.body) document.body.appendChild(mobileAtc);
    var primaryActionVisible = true;
    function syncMobileVisibility() {
      if (mobileAtc) mobileAtc.hidden = primaryActionVisible;
    }
    function updateMobileAtc(price, label, disabled) {
      if (!mobileAtc) return;
      mobilePrice.textContent = money(price);
      mobileButton.textContent = label;
      mobileButton.disabled = Boolean(disabled);
      mobileButton.setAttribute('aria-disabled', String(Boolean(disabled)));
      syncMobileVisibility();
    }
    if (nativeButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        primaryActionVisible = entries[0].isIntersecting;
        syncMobileVisibility();
      }).observe(nativeButton);
    } else if (nativeButton) {
      var checkPrimaryAction = function () {
        var bounds = nativeButton.getBoundingClientRect();
        primaryActionVisible = bounds.top < window.innerHeight && bounds.bottom > 0;
        syncMobileVisibility();
      };
      window.addEventListener('scroll', checkPrimaryAction, { passive: true });
      window.addEventListener('resize', checkPrimaryAction);
      checkPrimaryAction();
    } else {
      primaryActionVisible = false;
    }
    var stickyMtoNote = null;
    if (kind === 'charm' && stickyButton && stickyButton.parentElement) {
      stickyMtoNote = stickyButton.parentElement.querySelector('[data-dv-sticky-mto]');
      if (!stickyMtoNote) {
        stickyMtoNote = document.createElement('span');
        stickyMtoNote.className = 'dv-native-pdp__sticky-mto';
        stickyMtoNote.setAttribute('data-dv-sticky-mto', '');
        stickyMtoNote.textContent = 'Made for you · Ships within 2–3 weeks';
        stickyMtoNote.hidden = true;
        stickyButton.parentElement.insertBefore(stickyMtoNote, stickyButton);
      }
    }
    var defaultButtonText = nativeButton ? (nativeButton.querySelector('.atc-text') || nativeButton).textContent.trim() : '';
    var ownChainParagraph = section.querySelector('.dv-own-chain-note > p:not(.dv-own-chain-note__scope)');
    var ownChainParagraphHTML = ownChainParagraph ? ownChainParagraph.innerHTML : '';
    var ownChainScope = section.querySelector('.dv-own-chain-note__scope');
    var ownChainScopeHTML = ownChainScope ? ownChainScope.innerHTML : '';
    var ownReturnBadge = root.querySelector('[data-dv-native-return-badge]');
    var accessoryPhotoContext = root.querySelector('[data-dv-accessory-photo-context]');
    if (kind === 'accessory' && !accessoryPhotoContext && materialFieldset) {
      accessoryPhotoContext = document.createElement('p');
      accessoryPhotoContext.className = 'dv-native-pdp__photo-context';
      accessoryPhotoContext.setAttribute('data-dv-accessory-photo-context', '');
      accessoryPhotoContext.hidden = true;
      materialFieldset.insertAdjacentElement('afterend', accessoryPhotoContext);
    }
    var returnClaimRows = Array.prototype.slice.call(section.querySelectorAll('.divetia-trust-badge--returns, [data-divetia-returns], h2,h3,h4,h5,h6,p,span,strong')).filter(function (node) {
      if (node === ownReturnBadge) return false;
      if (node.matches('.divetia-trust-badge--returns, [data-divetia-returns]')) return true;
      return /14[- ]day\s*return window/i.test(node.textContent.trim()) && !Array.prototype.some.call(node.children, function (child) {
        return /14[- ]day\s*return window/i.test(child.textContent.trim());
      });
    }).map(function (node) {
      return node.closest('li, .sf-icon-box, .prod__trust-badge, [class*="trust-item"], [class*="icon-box"]') || node;
    }).filter(function (node, index, rows) { return rows.indexOf(node) === index; });
    returnClaimRows.forEach(function (node) {
      node.dataset.dvOriginallyHidden = String(node.hidden);
      node.dataset.dvOriginalDisplay = node.style.display || '';
    });
    var fitCopy = Array.prototype.slice.call(document.querySelectorAll('main p')).filter(function (node) {
      return /The link needs to fit through the 2 mm opening|The chain end needs to fit through the 6 mm space inside/.test(node.textContent);
    }).map(function (node) { return { node: node, text: node.textContent }; });
    var lastDispatchAt = 0;
    var lastRenderedMaterial = null;

    function refreshNativeGallery() {
      window.requestAnimationFrame(function () {
        section.querySelectorAll('.sf-product-media__desktop .swiper-container, .sf-product-media__mobile .swiper-container').forEach(function (slider) {
          if (slider.swiper && typeof slider.swiper.update === 'function') slider.swiper.update();
        });
        window.dispatchEvent(new Event('resize'));
      });
    }

    function syncTitle(isSilver) {
      var desired = product.name + ' — ' + (isSilver ? stoneLabels()[state.stone] : materialName(state.material));
      section.querySelectorAll('[data-divetia-variant-title], .prod__title h1').forEach(function (node) {
        if (node.textContent.trim() !== desired) node.textContent = desired;
      });
    }

    function syncAccessoryTitle(isSilver) {
      nativeTitleRows.forEach(function (item) {
        var desired = isSilver ? item.text : product.name + ' — 18K Gold Plated';
        if (item.node.textContent !== desired) item.node.textContent = desired;
      });
    }

    function syncEndlessDescription(isSilver) {
      if (!endlessDescription) return;
      var paragraph = Array.prototype.slice.call(endlessDescription.querySelectorAll('p')).find(function (node) {
        return /A lab-grown (?:sapphire|white diamond) center/.test(node.textContent);
      });
      if (!paragraph) return;
      var desired = paragraph.textContent.replace(/A lab-grown (?:sapphire|white diamond) center/, isSilver ? 'A lab-grown sapphire center' : 'A lab-grown white diamond center');
      if (paragraph.textContent !== desired) paragraph.textContent = desired;
    }

    function syncNativeText() {
      if (state.kind !== 'charm') return;
      var isSilver = state.material === 'silver';
      syncTitle(isSilver);
      syncEndlessDescription(isSilver);
      if (isSilver) syncSilverOptionLabels(section, product, state.stone);
    }

    function dispatchCurrent() {
      if (state.kind === 'charm' && state.material === 'solid' && (window.DV_SOLID_PREVIEW_LOCKED || !Number(window.DV_GOLD_VARIANTS && window.DV_GOLD_VARIANTS[state.family]))) {
        /* Solid preview is locked while the gold products remain drafts: the button looks
           exactly as on launch day, but a click sends nothing and shows nothing. */
        if (window.console && console.info) console.info('DIVETIA preview: Solid 14K Gold ordering is locked; nothing was sent.');
        return;
      }
      var now = Date.now();
      if (now - lastDispatchAt < 250) return;
      lastDispatchAt = now;
      dispatchReview(root, state);
    }

    function render() {
      if (state.kind === 'accessory') {
        if (state.material === 'plated' && platedChainAvailability(product.id) === 'hidden') {
          state.material = 'silver';
          writeState(state, false);
        }
        var accessoryIsSilver = state.material === 'silver';
        var accessoryAvailability = accessoryIsSilver ? 'available' : platedChainAvailability(product.id);
        var accessoryWaitlist = !accessoryIsSilver && accessoryAvailability !== 'available';
        var accessoryPrice = accessoryIsSilver ? product.price : platedAccessoryPrice(product);
        var accessoryCompare = null; // Current silver chains have no live compare-at price.
        var accessorySaving = accessoryCompare && accessoryCompare > accessoryPrice ? accessoryCompare - accessoryPrice : 0;
        section.classList.remove('dv-native-pdp--gold-active', 'dv-native-pdp--solid-active');
        section.classList.toggle('dv-native-pdp--plated-active', !accessoryIsSilver);
        section.classList.toggle('dv-native-pdp--plated-accessory-active', !accessoryIsSilver);
        if (materialFieldset) materialFieldset.hidden = false;
        root.querySelector('[data-dv-material-label]').textContent = accessoryMaterialName(state.material);
        root.querySelectorAll('[data-dv-material]').forEach(function (button) {
          var unavailable = button.dataset.dvMaterial === 'solid' || (button.dataset.dvMaterial === 'plated' && platedChainAvailability(product.id) === 'hidden');
          button.hidden = unavailable;
          button.setAttribute('aria-pressed', String(!unavailable && button.dataset.dvMaterial === state.material));
        });
        if (materialNote) materialNote.textContent = accessoryIsSilver
          ? 'Solid .925 sterling silver plated with rhodium for a brighter white finish and added resistance to tarnish.'
          : '18K gold plating over .925 sterling silver. This is a gold-plated finish, not solid gold.';
        priceNode.innerHTML = '<strong>' + money(accessoryPrice) + '</strong>' +
          (accessoryCompare ? '<s aria-label="Previous price">' + money(accessoryCompare) + '</s>' : '') +
          (accessorySaving ? '<em class="dv-native-pdp__saving">Save ' + money(accessorySaving) + '</em>' : '');
        availabilityNode.textContent = accessoryIsSilver || accessoryAvailability === 'available'
          ? 'In stock · Ships within 2 business days'
          : 'Gold-plated finish · Join the waitlist for release updates';
        availabilityNode.classList.remove('dv-native-pdp__availability--mto');
        if (accessoryPhotoContext) {
          accessoryPhotoContext.hidden = accessoryIsSilver;
          accessoryPhotoContext.textContent = accessoryIsSilver ? '' : 'Photos show the silver finish and are provided as a style reference. The gold-plated finish is not pictured.';
        }
        syncAccessoryTitle(accessoryIsSilver);
        if (ownChainScope) ownChainScope.innerHTML = accessoryIsSilver
          ? ownChainScopeHTML
          : '18K gold-plated .925 sterling silver chain. Chain only; charms sold separately.';
        if (detailsProof) detailsProof.hidden = !accessoryIsSilver;
        if (goldProof) {
          goldProof.hidden = accessoryIsSilver;
          if (!accessoryIsSilver) goldProof.innerHTML = platedAccessoryAboutHTML(product);
        }
        if (deliveryContent) deliveryContent.innerHTML = accessoryIsSilver || accessoryAvailability === 'available'
          ? '<p><strong>Delivery:</strong> In-stock orders ship within 2 business days. Insured U.S. shipping: Standard $12.95 (2–5 business days after shipment) or Priority $19.95 (2–3 business days after shipment). Tracking and full-value insurance are included; high-value shipments may require a signature.</p><p><strong>Returns:</strong> Contact DIVETIA within 14 days of delivery. <a href="/policies/refund-policy">Read the full returns policy.</a></p>'
          : '<p><strong>Release:</strong> Availability and delivery timing will be sent to waitlist members before ordering opens. Tracking and full-value insurance are included when orders ship.</p><p><strong>Returns:</strong> Contact DIVETIA within 14 days of delivery. Return the piece unworn, undamaged, and complete with its original packaging. <a href="/policies/refund-policy">Read the full returns policy.</a></p>';
        setButtonText(nativeButton, accessoryWaitlist ? 'Join the Waitlist' : 'Add to Bag');
        if (stickyButton) setButtonText(stickyButton, accessoryWaitlist ? 'Join the Waitlist' : 'Add to Bag');
        updateMobileAtc(accessoryPrice, accessoryWaitlist ? 'Join the waitlist' : 'Add to Bag', false);
        return;
      }

      if (state.kind === 'set') {
        var setPair = product.silver[state.stone] || product.silver.sapphire;
        var selectedChain = chainFor(state.chain);
        var selectedChainReference = selectedChain && accessoryForChain(selectedChain.id);
        var defaultSetChain = chainFor(root.dataset.setChain);
        var alternateSetChain = Boolean(selectedChain && defaultSetChain && selectedChain.id !== defaultSetChain.id);
        var setPrice = selectedSetPrice(root, form, product, state.stone, selectedChain);
        var setCompare = alternateSetChain ? null : setPair[1] + (selectedChainReference && selectedChainReference.native ? selectedChainReference.native[3] : 0);
        priceNode.innerHTML = '<strong>' + money(setPrice) + '</strong>' +
          (setCompare ? '<s aria-label="Previous price">' + money(setCompare) + '</s>' : '') +
          (setCompare > setPrice ? '<em class="dv-native-pdp__saving">Save ' + money(setCompare - setPrice) + '</em>' : '') +
          (alternateSetChain ? '<span class="dv-native-pdp__bundle-saving">Charm + chain · 10% off chain in bag</span>' : '');
        chainFieldset.hidden = false;
        var wantsBracelet = state.chain && state.chain.indexOf('bracelet') !== -1;
        var options = (catalog().chainOptions || []).filter(function (item) { return item.id !== 'none' && (item.id.indexOf('bracelet') !== -1) === wantsBracelet; });
        root.querySelector('[data-dv-chain-options]').innerHTML = options.map(function (item) {
          var optionPrice = selectedSetPrice(root, form, product, state.stone, item);
          var optionLabel = item.id === root.dataset.setChain ? 'Original set' : 'Charm + chain · 10% off chain';
          return '<button type="button" data-dv-chain="' + item.id + '" aria-pressed="' + String(item.id === state.chain) + '"><strong>' + item.name + '</strong> <small>' + optionLabel + ' · ' + money(optionPrice) + '</small></button>';
        }).join('');
        root.querySelector('[data-dv-chain-label]').textContent = selectedChain ? selectedChain.name : '';
        root.querySelector('[data-dv-availability]').textContent = 'In stock · Ships within 2 business days';
        if (setIntro && selectedChain) setIntro.innerHTML = '<strong>Includes:</strong> ' + product.name + ' in ' + stoneLabels()[state.stone].toLowerCase() + ' + the ' + selectedChain.name;
        if (setFoundation && selectedChain) setFoundation.innerHTML = '<strong>Necklace or bracelet:</strong> ' + selectedChain.name + ' · ' + selectedChain.note.split(' · $')[0];
        if (ownChainParagraph) ownChainParagraph.innerHTML = alternateSetChain
          ? 'Your selected pairing includes the ' + product.name + ' ' + stoneLabels()[state.stone].toLowerCase() + ' charm and the ' + selectedChain.name + '. You can also move the charm to another chain when its link or connector fits inside the lock opening.'
          : ownChainParagraphHTML;
        if (ownChainScope) ownChainScope.innerHTML = alternateSetChain
          ? 'The ' + selectedChain.name + ' is included in your selected pairing.'
          : ownChainScopeHTML;
        if (pairingParagraph) pairingParagraph.innerHTML = alternateSetChain
          ? 'The ' + selectedChain.name + ' gives ' + product.name + ' a different sterling-silver foundation while keeping the charm as the focus.'
          : pairingHTML;
        if (setPhotoContext) {
          setPhotoContext.hidden = !alternateSetChain;
          if (alternateSetChain) setPhotoContext.textContent = 'Photos show the original ' + defaultSetChain.name + ' pairing; your selected chain is ' + selectedChain.name + '.';
        }
        if (deliveryContent) deliveryContent.innerHTML = '<p><strong>Delivery:</strong> In-stock orders ship within 2 business days. Insured U.S. shipping: Standard $12.95 (2–5 business days after shipment) or Priority $19.95 (2–3 business days after shipment). Tracking and full-value insurance are included; high-value shipments may require a signature.</p><p><strong>Returns:</strong> Contact DIVETIA within 14 days of delivery. Return the pieces unworn, undamaged, and complete with their original packaging and Certificate of Authenticity. <a href="/policies/refund-policy">Read the full returns policy.</a></p>';
        setButtonText(nativeButton, alternateSetChain ? 'Add Pair to Bag' : 'Add Set to Bag');
        updateMobileAtc(setPrice, alternateSetChain ? 'Add Pair to Bag' : 'Add Set to Bag', false);
        return;
      }

      var isSilver = state.material === 'silver';
      var hasGoldChainState = !isSilver && (state.chain !== 'none' || new URLSearchParams(window.location.search).has('dv_chain'));
      if (hasGoldChainState) {
        state.chain = 'none';
        writeState(state, false);
      }
      var pair = product.silver[state.stone] || product.silver.sapphire;
      var selectedCharmChain = isSilver ? chainFor(state.chain) : null;
      if (selectedCharmChain && selectedCharmChain.id === 'none') selectedCharmChain = null;
      var waitsForRelease = state.material === 'plated';
      var selectedCharmChainReference = isSilver && selectedCharmChain && accessoryForChain(selectedCharmChain.id);
      var price = (isSilver ? pair[0] : product[state.material]) + (selectedCharmChain ? selectedCharmChain.price : 0);
      var selectedBundleSaving = bundleSaving(selectedCharmChain, selectedCharmChainReference);
      var compare = isSilver ? pair[1] + (selectedCharmChain ? standaloneChainPrice(selectedCharmChain, selectedCharmChainReference) : 0) : null;
      var saving = compare && compare > price ? compare - price : 0;

      fitCopy.forEach(function (item) {
        item.node.textContent = isSilver ? item.text : item.text
          .replace('The link needs to fit through the 2 mm opening.', 'Check that your chain link fits through this charm’s lock opening before ordering.')
          .replace('The chain end needs to fit through the 6 mm space inside.', 'Check that your chain end fits through this charm’s closed lock before ordering.');
      });
      section.classList.toggle('dv-native-pdp--gold-active', !isSilver);
      section.classList.toggle('dv-native-pdp--plated-active', state.material === 'plated');
      section.classList.toggle('dv-native-pdp--solid-active', state.material === 'solid');
      if (goldGallery) goldGallery.sync(state.material === 'solid');
      root.querySelector('[data-dv-material-label]').textContent = state.material === 'plated' ? 'Gold-Plated .925 Sterling Silver' : materialName(state.material);
      root.querySelectorAll('[data-dv-material]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.dvMaterial === state.material));
      });
      if (materialNote) {
        materialNote.textContent = isSilver
          ? '.925 sterling silver finished in rhodium, a precious metal that gives it a brighter white shine and added resistance to tarnish.'
          : state.material === 'plated'
            ? '2.5-micron gold plating over .925 sterling silver.'
            : 'Solid 14K yellow gold charm with an openable lock, set with lab-grown gemstones. Wear it on one of our sterling silver chains or your own.';
      }
      if (stoneFieldset) {
        stoneFieldset.hidden = false;
        var hasStoneChoice = isSilver && product.stones.length > 1;
        var stoneOptions = hasStoneChoice ? product.stones : [];
        stoneOptionsNode.hidden = !hasStoneChoice;
        stoneOptionsNode.innerHTML = stoneOptions.map(function (stone) {
          var label = stoneLabels()[stone];
          var pressed = stone === state.stone;
          return '<button type="button" data-dv-stone="' + stone + '" aria-pressed="' + String(pressed) + '"><span class="dv-native-pdp__gem dv-native-pdp__gem--' + stone + '" aria-hidden="true"></span>' + label + '</button>';
        }).join('');
        stoneCombination.hidden = hasStoneChoice;
        stoneCombination.innerHTML = hasStoneChoice ? '' : '<span>' + (isSilver ? stoneLabels()[state.stone] : goldStoneLabel(state.family)) + '</span>';
        stoneFieldset.classList.toggle('dv-native-pdp__stone-fixed', !hasStoneChoice);
        root.querySelector('[data-dv-stone-label]').textContent = isSilver
          ? stoneLabels()[state.stone]
          : goldStoneLabel(state.family);
      }
      if (chainDisclosure) chainDisclosure.hidden = !isSilver;
      chainFieldset.hidden = !isSilver;
      var chainOptions = (isSilver ? (catalog().chainOptions || []) : []).filter(function (item) {
        return item.id !== 'none';
      });
      root.querySelector('[data-dv-chain-options]').innerHTML = chainOptions.map(function (item) {
        var reference = accessoryForChain(item.id);
        var standalone = standaloneChainPrice(item, reference);
        var optionSaving = bundleSaving(item, reference);
        var thumb = reference && reference.image;
        var image = thumb ? '<img src="' + thumb + '" alt="" loading="lazy">' : '<span class="dv-native-pdp__chain-image" aria-hidden="true"></span>';
        return '<button type="button" data-dv-chain="' + item.id + '" aria-pressed="' + String(item.id === state.chain) + '">' +
          image + '<span class="dv-native-pdp__chain-name"><strong>' + item.name + '</strong></span>' +
          '<span class="dv-native-pdp__chain-price"><strong>With a charm ' + money(item.price) + '</strong>' +
          (standalone && standalone > item.price ? '<s>' + money(standalone) + ' separately</s>' : '') +
          (optionSaving ? '<em>Save 10% (' + money(optionSaving) + ')</em>' : '') + '</span></button>';
      }).join('') + (selectedCharmChain ? '<button type="button" class="dv-native-pdp__chain-remove" data-dv-chain="none">Remove chain</button>' : '');
      var chainPhotoNote = root.querySelector('[data-dv-chain-photo-note]');
      if (!chainPhotoNote && chainDisclosure) {
        chainPhotoNote = document.createElement('p');
        chainPhotoNote.setAttribute('data-dv-chain-photo-note', '');
        chainPhotoNote.className = 'dv-native-pdp__photo-context';
        chainFieldset.appendChild(chainPhotoNote);
      }
      if (chainPhotoNote) {
        chainPhotoNote.hidden = true;
        chainPhotoNote.textContent = '';
      }
      if (chainSummary) {
        chainSummary.innerHTML = selectedCharmChain
          ? '<strong>' + selectedCharmChain.name + '</strong><span>+' + money(selectedCharmChain.price) + ' with a charm' + (selectedBundleSaving ? ' · Save 10% (' + money(selectedBundleSaving) + ')' : '') + '</span>'
          : '<strong>Use my own chain</strong><span>Add a chain</span>';
      }
      var chainLabel = root.querySelector('[data-dv-chain-label]');
      if (chainLabel) chainLabel.textContent = selectedCharmChain ? selectedCharmChain.name : 'Use my own chain';
      if (isSilver) syncSilverOptionLabels(section, product, state.stone);
      if (ownChainScope) {
        ownChainScope.innerHTML = !isSilver
          ? 'Wear it on one of our sterling silver chains or your own.'
          : selectedCharmChain
          ? selectedCharmChain.name + ' selected. This piece includes the charm and selected chain.'
          : ownChainScopeHTML;
      }
      priceNode.innerHTML = '<strong>' + money(price) + '</strong>' +
        (compare ? '<s aria-label="Previous price">' + money(compare) + '</s>' : '') +
        (saving ? '<em class="dv-native-pdp__saving">Save ' + money(saving) + '</em>' : '') +
        (selectedBundleSaving ? '<span class="dv-native-pdp__bundle-saving">Chain: save 10% (' + money(selectedBundleSaving) + ')</span>' : '');

      syncTitle(isSilver);
      syncEndlessDescription(isSilver);
      returnClaimRows.forEach(function (node) {
        var hasStandardReturns = true;
        node.hidden = hasStandardReturns ? node.dataset.dvOriginallyHidden === 'true' : true;
        node.style.display = hasStandardReturns ? node.dataset.dvOriginalDisplay : 'none';
      });
      var hasStandardReturns = true;
      if (ownReturnBadge) {
        var showFallbackBadge = hasStandardReturns && returnClaimRows.length === 0;
        ownReturnBadge.hidden = !showFallbackBadge;
        ownReturnBadge.style.display = showFallbackBadge ? '' : 'none';
      }
      if (detailsProof) detailsProof.hidden = !isSilver;
      if (goldProof) {
        goldProof.hidden = isSilver;
        if (!isSilver) goldProof.innerHTML = goldAboutHTML(product, state.material, state.family, selectedCharmChain);
      }
      if (deliveryContent) {
        deliveryContent.innerHTML = isSilver ? deliveryHTML : state.material === 'plated'
          ? '<p><strong>Release:</strong> Availability and delivery timing will be sent to waitlist members before ordering opens. Tracking and full-value insurance are included when orders ship.</p><p><strong>Returns:</strong> Contact DIVETIA within 14 days of delivery. Return the piece unworn, undamaged, and complete with its original packaging and Certificate of Authenticity. <a href="/policies/refund-policy">Read the full returns policy.</a></p>'
          : '<p><strong>Made to order:</strong> Your solid gold charm is made after you order and ships within 2–3 weeks.</p><p><strong>Returns &amp; cancellations:</strong> Free cancellation until production begins. Free 14-day returns after delivery for unworn pieces returned complete in their original box.</p>';
      }
      availabilityNode.textContent = isSilver
        ? 'In stock · Ships within 2 business days'
        : waitsForRelease
          ? 'Join the waitlist for release updates'
          : 'Made for you · Ships within 2–3 weeks';
      availabilityNode.classList.toggle('dv-native-pdp__availability--mto', state.material === 'solid');
      availabilityNode.hidden = false;

      if (stickyMtoNote) stickyMtoNote.hidden = state.material !== 'solid';

      // Only a genuinely missing gold variant disables ordering. The preview lock keeps the
      // launch-day button and is enforced in dispatchCurrent instead.
      var missingGold = state.material === 'solid' && !Number(window.DV_GOLD_VARIANTS && window.DV_GOLD_VARIANTS[state.family]);
      if (nativeButton) {
        setButtonText(nativeButton, waitsForRelease ? 'Join the Waitlist' : state.material === 'solid' ? 'Order Yours' : 'Add to Bag');
        if (missingGold) {
          nativeButton.setAttribute('disabled', 'disabled');
          nativeButton.setAttribute('aria-disabled', 'true');
        } else {
          nativeButton.removeAttribute('disabled');
          nativeButton.setAttribute('aria-disabled', 'false');
        }
      }
      if (stickyButton) {
        setButtonText(stickyButton, waitsForRelease ? 'Join the Waitlist' : state.material === 'solid' ? 'Order Yours' : 'Add to Bag');
        stickyButton.disabled = missingGold;
      }
      updateMobileAtc(price, waitsForRelease ? 'Join the waitlist' : state.material === 'solid' ? 'Order yours' : 'Add to Bag', missingGold);
      if (isSilver && lastRenderedMaterial && lastRenderedMaterial !== 'silver') refreshNativeGallery();
      lastRenderedMaterial = state.material;
    }

    root.addEventListener('click', function (event) {
      var chainButton = event.target.closest('[data-dv-chain]');
      if (chainButton) {
        state.chain = chainButton.dataset.dvChain;
        writeState(state, true);
        render();
        return;
      }
      var stoneButton = event.target.closest('[data-dv-stone]');
      if (stoneButton) {
        if (stoneButton.dataset.dvStone !== 'gold') {
          state.stone = stoneButton.dataset.dvStone;
          restoreNativeStoneSelection(section, product, state.stone);
          writeState(state, true);
          render();
        }
        return;
      }
      var button = event.target.closest('[data-dv-material]');
      if (!button) return;
      if (button.dataset.dvMaterial !== 'silver' && !(state.kind === 'charm' && button.dataset.dvMaterial === 'solid')) return;
      // One URL per material: gold pages link back to silver, and once gold is live silver links to gold.
      if (state.goldPage && button.dataset.dvMaterial === 'silver') {
        window.location.assign('/products/' + root.dataset.productHandle.replace(/-solid-14k-gold$/, '-sapphire'));
        return;
      }
      var goldHref = !state.goldPage && button.dataset.dvMaterial === 'solid' && window.DVGoldHref && window.DVGoldHref(window.location.pathname);
      if (goldHref) {
        window.location.assign(goldHref);
        return;
      }
      state.material = button.dataset.dvMaterial;
      if (state.kind === 'charm' && state.material !== 'silver') state.chain = 'none';
      writeState(state, true);
      render();
    });

    form.addEventListener('change', function () {
      window.setTimeout(function () {
        state.stone = selectedStoneFromPicker(section) || stoneToken(selectedVariant(form).title || root.dataset.productTitle);
        if (state.kind === 'charm') writeState(state, false);
        render();
      }, 120);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      dispatchCurrent();
    }, true);

    if (nativeButton) {
      nativeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        dispatchCurrent();
      }, true);
    }

    if (stickyButton && stickyButton !== nativeButton) {
      stickyButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        dispatchCurrent();
      }, true);
    }

    if (mobileButton) mobileButton.addEventListener('click', dispatchCurrent);

    window.addEventListener('dv:native:submit-pdp', function (event) {
      if (event.detail && event.detail.form === form) dispatchCurrent();
    });

    window.addEventListener('popstate', function () {
      if (state.goldPage) return;
      var next = new URLSearchParams(window.location.search);
      var nextMaterial = next.get('dv_material');
      state.material = state.kind === 'charm' && nextMaterial === 'solid' ? 'solid' : 'silver';
      var nextChain = next.get('dv_chain');
      if (state.kind === 'charm') {
        state.chain = state.material === 'silver' && chainFor(nextChain) ? nextChain : 'none';
        state.stone = explicitVariantStone(form, product, next) || stoneFromPath(product) || stoneToken(root.dataset.productTitle);
        restoreNativeStoneSelection(section, product, state.stone);
      }
      if (state.kind === 'set') state.chain = compatibleSetChain(nextChain, root.dataset.setChain) ? nextChain : root.dataset.setChain;
      // The theme's native picker can write its original product's variant ID
      // during selection. Run this after the picker so Back/Forward stays clean.
      if (state.kind === 'charm' || nextMaterial === 'solid' || nextMaterial === 'plated') writeState(state, false);
      render();
    });

    window.addEventListener('pagehide', function () {
      if (nativeButton && defaultButtonText) setButtonText(nativeButton, defaultButtonText);
    }, { once: true });
    // Back/Forward restores this page from the bfcache after pagehide reset the button; re-render its real state.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) render();
    });

    var textSyncPending = false;
    function scheduleNativeTextSync() {
      if (textSyncPending) return;
      textSyncPending = true;
      window.requestAnimationFrame(function () {
        textSyncPending = false;
        syncNativeText();
      });
    }
    var picker = section.querySelector('.main-product__block-variant_picker');
    if (endlessDescription) new MutationObserver(scheduleNativeTextSync).observe(endlessDescription, { childList: true, characterData: true, subtree: true });
    if (picker) new MutationObserver(scheduleNativeTextSync).observe(picker, { childList: true, characterData: true, subtree: true });
    if (titleContainer) new MutationObserver(scheduleNativeTextSync).observe(titleContainer, { childList: true, characterData: true, subtree: true });

    if (state.kind === 'charm') {
      restoreNativeStoneSelection(section, product, state.stone);
      // Native picker URL updates are synchronous; canonicalize after them.
      writeState(state, false);
    }
    if (chainDisclosure && state.material === 'silver' && queryChain && queryChain !== 'none' && chainFor(queryChain)) chainDisclosure.open = true;
    render();
  }

  function boot() {
    document.querySelectorAll('[data-dv-native-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());

// Gold PDPs only: show Shopify's own Shop Pay Installments banner (default Shopify wording) under the
// native price, plus a charm-only note under the order button. Silver and set pages return before touching the DOM.
(function () {
  'use strict';

  var NOTE_HTML = 'Charm only — wear it on a chain you already own, or pair it with one of our <a href="/collections/silver-bracelets-and-necklaces">sterling silver chains</a>.';

  function goldRoot(root) {
    return root.dataset.kind === 'charm' && /-solid-14k-gold$/.test(root.dataset.productHandle || '');
  }

  function apply(root) {
    if (!goldRoot(root) || root.dataset.dvReady !== 'true') return false;
    var section = root.closest('.dv-native-pdp-active');
    var form = root.closest('form');
    var priceNode = root.querySelector('[data-dv-price]');
    if (!section || !form || !priceNode) return false;

    var terms = form.querySelector('shopify-payment-terms');
    var gold = window.DV_GOLD_VARIANTS && Number(window.DV_GOLD_VARIANTS[root.dataset.family]);
    if (terms && gold && Number(terms.getAttribute('variant-id')) !== gold) terms = null; // Never advertise another variant.
    if (terms) {
      var box = root.querySelector('[data-dv-gold-spi]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'dv-gold-spi';
        box.setAttribute('data-dv-gold-spi', '');
        box.innerHTML = '<div class="dv-gold-spi__banner"></div>';
        priceNode.insertAdjacentElement('afterend', box);
      }
      var banner = box.querySelector('.dv-gold-spi__banner');
      if (terms.parentElement !== banner) banner.appendChild(terms);
    }

    var actions = form.querySelector('.product-form__actions');
    if (actions && !form.querySelector('[data-dv-gold-charm-only]')) {
      var note = document.createElement('p');
      note.className = 'dv-gold-charm-only';
      note.setAttribute('data-dv-gold-charm-only', '');
      note.innerHTML = NOTE_HTML;
      actions.insertAdjacentElement('afterend', note);
    }
    return true;
  }

  function run() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-dv-native-pdp]')).filter(goldRoot);
    if (!roots.length) return;
    var frames = 0;
    (function attempt() {
      var pending = roots.filter(function (root) { return !apply(root); });
      if (pending.length && ++frames < 120) { roots = pending; window.requestAnimationFrame(attempt); }
    }());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('pageshow', function (event) { if (event.persisted) run(); });
  document.addEventListener('shopify:section:load', run);
}());

// Silver relaunch PDPs (charms, chains, bracelets, sets): show Shopify's own Shop Pay Installments banner
// (default Shopify wording) under the native price. Gold pages are left to the gold block above.
// The banner follows the form's selected variant; it is hidden whenever the shown price is not that
// variant's Shopify price (e.g. a chain add-on or plated waitlist) or Shopify reports it ineligible.
(function () {
  'use strict';

  function silverRoot(root) {
    return !/-solid-14k-gold$/.test(root.dataset.productHandle || '');
  }

  function amount(text) {
    var match = String(text || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : NaN;
  }

  function sync(root) {
    var box = root.querySelector('[data-dv-silver-spi]');
    var form = root.closest('form');
    var terms = box && box.querySelector('shopify-payment-terms');
    if (!box || !form || !terms) return;
    var input = form.querySelector('[name="id"]');
    var shown = root.querySelector('[data-dv-price] strong');
    var meta = null;
    try { meta = JSON.parse(terms.getAttribute('shopify-meta') || 'null'); } catch (_error) {}
    var id = Number(input && input.value);
    var variant = meta && Array.isArray(meta.variants) && meta.variants.find(function (item) { return Number(item.id) === id; });
    var price = variant ? Number(variant.full_price_amount) : NaN;
    var show = Boolean(variant && variant.eligible && shown) &&
      price >= Number(meta.min_price_amount || 0) && price <= Number(meta.max_price_amount || Infinity) &&
      Math.abs(amount(shown.textContent) - price) < 0.005; // Never advertise a plan for a different price.
    if (box.hidden === show) box.hidden = !show;
  }

  function apply(root) {
    if (!silverRoot(root) || root.dataset.dvReady !== 'true') return false;
    var section = root.closest('.dv-native-pdp-active');
    var form = root.closest('form');
    var priceNode = root.querySelector('[data-dv-price]');
    if (!section || !form || !priceNode) return false;
    var terms = form.querySelector('shopify-payment-terms');
    if (!terms) return true; // Shopify rendered no banner: show nothing.

    var box = root.querySelector('[data-dv-silver-spi]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'dv-silver-spi';
      box.setAttribute('data-dv-silver-spi', '');
      box.hidden = true;
      box.innerHTML = '<div class="dv-silver-spi__banner"></div>';
      priceNode.insertAdjacentElement('afterend', box);
    }
    var banner = box.querySelector('.dv-silver-spi__banner');
    if (terms.parentElement !== banner) banner.appendChild(terms);

    if (!root.dataset.dvSilverSpiBound) {
      root.dataset.dvSilverSpiBound = 'true';
      var pending = false;
      var schedule = function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () { pending = false; sync(root); });
      };
      new MutationObserver(schedule).observe(priceNode, { childList: true, characterData: true, subtree: true });
      // Stone/variant picks update the theme's variant input, then relaunch re-renders the price ~120ms later.
      form.addEventListener('change', function () { window.setTimeout(schedule, 200); });
      root.addEventListener('click', function () { window.setTimeout(schedule, 200); });
    }
    sync(root);
    return true;
  }

  function run() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-dv-native-pdp]')).filter(silverRoot);
    if (!roots.length) return;
    var frames = 0;
    (function attempt() {
      var pending = roots.filter(function (root) { return !apply(root); });
      if (pending.length && ++frames < 120) { roots = pending; window.requestAnimationFrame(attempt); }
    }());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('pageshow', function (event) { if (event.persisted) run(); });
  document.addEventListener('shopify:section:load', run);
}());

// Gold + silver relaunch PDPs: make Shopify's Shop Pay banner easy to tap. The whole banner row (44px hit area)
// opens Shopify's own sample-plans pop-up by pressing its own trigger button; no financing text of ours is added.
// If Shopify's trigger can't be reached (e.g. it moves behind a closed shadow root), nothing extra is shown.
(function () {
  'use strict';

  var LABEL = 'See payment options'; // Optional visible link text under the banner; empty = tap-target only.

  function trigger(box) {
    var terms = box.querySelector('shopify-payment-terms');
    var shadow = terms && terms.shadowRoot;
    return shadow && shadow.querySelector('#shopify-installments-cta, [data-testid="shopify-installments-cta"]');
  }

  function prepare(box) {
    if (box.dataset.dvSpiPrepared) return;
    box.dataset.dvSpiPrepared = 'true';
    if (LABEL) {
      // Reserve the label line before Shop Pay hydrates (no layout shift); it stays invisible until the trigger exists.
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'dv-spi-more';
      more.setAttribute('aria-haspopup', 'dialog');
      more.setAttribute('data-dv-spi-pending', '');
      more.tabIndex = -1;
      more.textContent = LABEL;
      box.appendChild(more);
    }
    box.addEventListener('click', function (event) {
      var current = trigger(box);
      if (!current || event.composedPath().indexOf(current) !== -1) return; // Shopify's own control handled it.
      event.preventDefault();
      current.click();
    });
  }

  function bind(box) {
    prepare(box);
    var banner = box.firstElementChild;
    if (!banner || !trigger(box)) return false;
    banner.classList.add('dv-spi-tap');
    var more = box.querySelector('.dv-spi-more[data-dv-spi-pending]');
    if (more) { more.removeAttribute('data-dv-spi-pending'); more.removeAttribute('tabindex'); }
    return true;
  }

  function run() {
    var tries = 0;
    (function attempt() {
      var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-dv-gold-spi], [data-dv-silver-spi]'));
      var pending = boxes.filter(function (box) { return !bind(box); });
      if ((pending.length || !boxes.length) && ++tries < 40) { window.setTimeout(attempt, 250); return; } // Shop Pay hydrates late.
      pending.forEach(function (box) { // Shopify's trigger never appeared: drop the unused label.
        var more = box.querySelector('.dv-spi-more[data-dv-spi-pending]');
        if (more) more.remove();
      });
    }());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('pageshow', function (event) { if (event.persisted) run(); });
  document.addEventListener('shopify:section:load', run);
}());

// Relaunch single-charm and chain PDPs: show Shopify's own accelerated checkout button (Shop Pay / Apple Pay /
// Buy it now, chosen by Shopify per shopper) under the order button. It buys the form's selected variant, qty 1,
// and skips the bag, so it is switched off whenever the bag path would add something it can't:
// sets, a chain add-on or any shown price that isn't the variant's own price, plated waitlist, and gold variants
// other than the verified gold id. Gold orders carry the same Production line property as Order Yours.
(function () {
  'use strict';

  var GOLD = { daisy: 54025981133083, bound: 54025981296923, blossom: 54025981591835, flutter: 54025981493531, paw: 54025981362459, endless: 54025981788443 };
  var PRODUCTION = 'Made to order · ships within 2–3 weeks'; // Same text real-commerce.js adds to gold lines.

  function amount(text) {
    var match = String(text || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : NaN;
  }

  function eligible(root, form) {
    var kind = root.dataset.kind || 'charm';
    if (kind !== 'charm' && kind !== 'accessory') return false;
    var input = form.querySelector('[name="id"]');
    var id = Number(input && input.value);
    if (!id) return false;
    var submit = form.querySelector('.add-to-cart[type="submit"], [type="submit"][name="add"]');
    if (submit && (submit.disabled || submit.getAttribute('aria-disabled') === 'true')) return false;
    var product = window._themeProducts && window._themeProducts[form.dataset.productId];
    var variant = product && Array.isArray(product.variants) && product.variants.find(function (item) { return Number(item.id) === id; });
    var shown = root.querySelector('[data-dv-price] strong');
    if (!variant || variant.available === false || !shown) return false;
    // Theme variant prices are in cents. Never offer a one-tap buy at a price other than the one on screen.
    if (Math.abs(amount(shown.textContent) * 100 - Number(variant.price)) >= 0.5) return false;
    if (/-solid-14k-gold$/.test(root.dataset.productHandle || '')) {
      return kind === 'charm' && !window.DV_SOLID_PREVIEW_LOCKED &&
        id === GOLD[root.dataset.family] && id === Number(window.DV_GOLD_VARIANTS && window.DV_GOLD_VARIANTS[root.dataset.family]);
    }
    return true;
  }

  function sync(root) {
    var form = root.closest('form');
    var express = form && form.querySelector('.prod__dynamic_checkout');
    if (!express) return;
    var on = eligible(root, form);
    if (express.getAttribute('data-dv-express') !== (on ? 'on' : 'off')) express.setAttribute('data-dv-express', on ? 'on' : 'off');
  }

  function apply(root) {
    if (root.dataset.dvReady !== 'true') return false;
    var form = root.closest('form');
    var priceNode = root.querySelector('[data-dv-price]');
    if (!form || !priceNode || !root.closest('.dv-native-pdp-active')) return false;
    if (!form.querySelector('.prod__dynamic_checkout')) return true;

    if (/-solid-14k-gold$/.test(root.dataset.productHandle || '') && !form.querySelector('[data-dv-express-production]')) {
      var production = document.createElement('input');
      production.type = 'hidden';
      production.name = 'properties[Production]';
      production.value = PRODUCTION;
      production.setAttribute('data-dv-express-production', '');
      form.appendChild(production);
    }

    if (!root.dataset.dvExpressBound) {
      root.dataset.dvExpressBound = 'true';
      var pending = false;
      var schedule = function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () { pending = false; sync(root); });
      };
      new MutationObserver(schedule).observe(priceNode, { childList: true, characterData: true, subtree: true });
      form.addEventListener('change', function () { window.setTimeout(schedule, 200); });
      root.addEventListener('click', function () { window.setTimeout(schedule, 200); });
    }
    sync(root);
    return true;
  }

  function run() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-dv-native-pdp]'));
    if (!roots.length) return;
    var frames = 0;
    (function attempt() {
      var pending = roots.filter(function (root) { return !apply(root); });
      if (pending.length && ++frames < 120) { roots = pending; window.requestAnimationFrame(attempt); }
    }());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('pageshow', function (event) { if (event.persisted) run(); });
  document.addEventListener('shopify:section:load', run);
}());

// GOLD-XMAS-2964: solid 14K gold PDPs only. Shows the Christmas order-by line next to the
// made-to-order availability line until Nov 24 2026 23:59 America/New_York (EST, UTC-5),
// evaluated in the shopper's browser so cached HTML/JS never shows it late. After the cutoff
// nothing is inserted, so no empty space is left behind. Synced in a MutationObserver
// microtask, i.e. in the same frame the availability line is filled (no extra layout shift).
(function () {
  'use strict';
  var CUTOFF = Date.UTC(2026, 10, 25, 5, 0, 0); // 2026-11-24 23:59:59.999 ET
  var MODE = 'line'; // 'line' = own line under availability; 'inline' = appended to it
  var TEXT = { line: 'Order by Nov 24 to arrive before Christmas.', inline: 'Order by Nov 24 for Christmas' };
  var now = function () { return Date.now(); };
  var isGold = function (root) { return /-solid-14k-gold$/.test(root.dataset.productHandle || ''); };

  function sync(node) {
    var live = now() < CUTOFF && !node.hidden && node.classList.contains('dv-native-pdp__availability--mto');
    if (MODE === 'inline') {
      var span = node.querySelector('[data-dv-xmas]');
      if (live && !span) {
        span = document.createElement('span');
        span.className = 'dv-native-pdp__xmas-inline';
        span.setAttribute('data-dv-xmas', '');
        span.appendChild(document.createTextNode(' · '));
        var phrase = document.createElement('span');
        phrase.className = 'dv-native-pdp__xmas-phrase';
        phrase.textContent = TEXT.inline;
        span.appendChild(phrase);
        node.appendChild(span);
      } else if (!live && span) span.parentNode.removeChild(span);
      return;
    }
    var line = node.nextElementSibling && node.nextElementSibling.hasAttribute('data-dv-xmas') ? node.nextElementSibling : null;
    if (live && !line) {
      line = document.createElement('p');
      line.className = 'dv-native-pdp__xmas';
      line.setAttribute('data-dv-xmas', '');
      line.textContent = TEXT.line;
      node.parentNode.insertBefore(line, node.nextSibling);
    }
    if (line) line.hidden = !live;
  }

  function run() {
    if (now() >= CUTOFF) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-dv-native-pdp]'), function (root) {
      if (!isGold(root)) return;
      var node = root.querySelector('[data-dv-availability]');
      if (!node) return;
      if (node.dataset.dvXmasBound !== 'true') {
        node.dataset.dvXmasBound = 'true';
        new MutationObserver(function () { sync(node); }).observe(node, { attributes: true, attributeFilter: ['class', 'hidden'], childList: true, characterData: true, subtree: true });
      }
      sync(node);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('pageshow', function (event) { if (event.persisted) run(); });
  document.addEventListener('shopify:section:load', run);
}());
